<template>

  <!-- Events Grid Block -->
  <items-loader
    no-autoload
    module="vlEvents"
    class="events-grid-block">

    <template
      slot-scope="{items, loading, hasMore, loadMore}">

      <page-block
        bg-image-contain
        v-if="items.length"
        :bg-file="value.file"
        :bg-color="value.bgColor"
        :text-color="value.textColor"
        :text-align="value.textAlign"
        :width-class="value.widthClass"
        :overlay-class="value.paddingClass">

        <page-block-header
          class="sbs-mb"
          :value="value">

          <div
            v-if="!isEvents">

            <span
              class="text-grey text-subtitle1">
              перейти в раздел
            </span>

            <q-btn
              rounded
              unelevated
              to="/events"
              color="grey-4"
              class="q-ml-sm"
              text-color="primary">

              <svg
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="currentColor">

                <use
                  xlink:href="/images/icons/icon-symbols.svg?v1#arrow-right"/>

              </svg>

            </q-btn>

          </div>

        </page-block-header>

        <div
          class="grid-5 grid-gap-3">

          <universal-link
            :key="item.id"
            v-for="item in items"
            :to="`/event/${item.slug}`">

            <event-card
              :value="item"
              class="hover-scale-2"/>

          </universal-link>

        </div>

        <q-btn
          rounded
          unelevated
          color="accent"
          @click="loadMore"
          :loading="loading"
          v-if="isEvents && hasMore"
          class="block-btn bs-mt max-width-100 no-wrap q-mb-none q-mx-auto block">
          Загрузить еще
        </q-btn>

      </page-block>

    </template>

  </items-loader>

</template>

<script>

  import EventCard from 'components/card/event-card';
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
  import PageBlock from '@src/components/page/page-block';
  import PageBlockHeader from '@src/components/page/page-block-header';

  export default {
    name: 'events-grid-block',
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      EventCard,
      PageBlock,
      PageBlockHeader,
    },
    computed: {
      isEvents() {

        return this.$route.name === 'public-events';
      },
    },
    methods: {
      ...mapActions('vlEvents', {
        fetch: 'FETCH_ITEMS',
      }),
      ...mapMutations('vlEvents', {
        setWhere: 'SET_WHERE',
      }),
    },
    mounted() {

      this.setWhere({
        published: true,
        notListed: {neq: true},
        endDate: {gte: new Date().toISOString()},
        publishedAt: {lte: new Date().toISOString()},
        public: this.$store.getters['session/isLoggedIn']
          ? undefined
          : true,
      });

      this.fetch();
    },
  };

</script>

<style lang="scss">

  .events-grid-block {
    color: inherit;
  }

</style>
